import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import React from 'react';
import { Project } from '@models/project.model';
import { ActiveProjectCard } from './ActiveProjectCard';
import { Loading } from '@components/atoms/Loading';
import { EmptyData } from '@components/molecules/EmptyData';
import { useTranslation } from '@hooks/useTranslation';

interface ActiveProjectsListProps {
  projects: Project[];
  isLoading?: boolean;
  onProjectClick: (projectId: string) => void;
  onShowGeofence?: (project: Project) => void;
  onToggleFavorite?: (projectId: string) => void;
}

export const ActiveProjectsList: React.FC<ActiveProjectsListProps> = ({
  projects,
  isLoading = false,
  onProjectClick,
  onShowGeofence,
  onToggleFavorite,
}) => {
  const tDashboard = useTranslation('dashboard');
  return (
    // Grid item that stretches to the row height and scrolls its list internally
    // (invisible scrollbar), so the rail stays put while the feed column scrolls
    // independently — and neither column makes the page scroll globally.
    <div className="flex flex-col pb-2 min-h-0 h-[calc(100vh-3rem)]">
      <div className="flex items-center ml-4 gap-4 flex-shrink-0 pt-1">
        <WorkOutlineOutlinedIcon
          sx={{ fontSize: 28 }}
          className="text-orange-400 dark:text-orange-300"
        />
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {tDashboard.activeProjects}
        </h1>
      </div>

      <div className="py-2 pl-4 flex flex-col gap-2 mt-8 flex-1 overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        {isLoading ? (
          <div className="flex justify-center py-[90%]">
            <Loading size="xl" />
          </div>
        ) : projects && projects.length > 0 ? (
          projects.map((project) => (
            <ActiveProjectCard
              key={project.projectId}
              project={project}
              onClick={onProjectClick}
              onShowGeofence={onShowGeofence}
              onToggleFavorite={onToggleFavorite}
            />
          ))
        ) : (
          <EmptyData description={tDashboard.noActiveProjects} fullHeight />
        )}
      </div>
    </div>
  );
};
